import React, { ReactNode } from 'react';

import * as S from './styles';

interface IProps {
  /** What is missing, as a sentence fragment. "No orders in this range". */
  title: string;
  /** Why it is missing, or what to do about it. */
  text?: ReactNode;
  /** A button, usually the action that would create the first record. */
  action?: ReactNode;
  /** Replaces the default glyph. Pass an <svg>, not an <img>. */
  icon?: ReactNode;
  /** 'sm' for empties nested inside a card body rather than replacing a table. */
  size?: 'sm' | 'md';
  className?: string;
  style?: object;
}

const defaultIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.5-3.5" />
  </svg>
);

/**
 * The empty state. 18 of the 23 tables rendered bare headers on an empty
 * result before this existed.
 *
 * Say what is missing and what to do next — never "No data".
 */
const Empty: React.FC<IProps> = ({ title, text, action, icon, size = 'md', className, style }) => {
  return (
    <S.Container className={`${size === 'sm' ? 'sm' : ''} ${className || ''}`.trim()} style={style}>
      <S.Icon>{icon || defaultIcon}</S.Icon>
      <S.Title>{title}</S.Title>
      {text ? <S.Text>{text}</S.Text> : <></>}
      {action ? <S.Action>{action}</S.Action> : <></>}
    </S.Container>
  );
};

export default Empty;
